import { useState, memo } from 'react';

import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';

import {
  Box, 
  Flex,
  Popover,
  PopoverArrow,
  PopoverContent,
  PopoverTrigger,
  useDisclosure
} from '@chakra-ui/react';
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton.jsx'

import { manageSharedDoc } from '../actions/dsr-actions';
import { IoCloseOutline, IoDocumentText } from 'react-icons/io5';
import { FaFileCircleCheck } from 'react-icons/fa6';
import LaunchdeckFormInput from '../../forms/TextInputField/components/LaunchdeckFormInput.jsx';
import LaunchdeckFormTextAreaInput from '../../forms/TextInputField/components/LaunchdeckFormTextAreaInput.jsx';
import LaunchdeckModal from '../../global/components/helper-components/components/LaunchdeckModal.jsx';



function EditSharedDocModal({
  dsrId,
  modalTransferPayload,
  handleCloseModal,
  // Actions
  manageSharedDoc,
  // Redux states
  isMobileView,
  dsrTemplateId,
  isRoomTemplate
}) {

  const { isOpen, onOpen, onClose, onToggle } = useDisclosure();
  const { editedSharedDocId, editedSharedDocName, editedSharedDocLink, editedSharedDocFileKey, editedSharedDocDescription } = modalTransferPayload || {};

  // Local state
  const [sharedDocLink, setSharedDocLink] = useState(editedSharedDocFileKey ? "" : editedSharedDocLink)
  const [sharedDocName, setSharedDocName] = useState(editedSharedDocName)
  const [docDescriptionInput, setDocDescriptionInput] = useState(editedSharedDocDescription)
  const [saveInProgress, setSaveInProgress] = useState(false)

  const handleSaveButton = () => {
    if (sharedDocName) {
      manageSharedDoc({
        dsrId: isRoomTemplate ? dsrTemplateId : dsrId,
        manageEvent: "edit-shared-doc",
        docId: editedSharedDocId,
        editedParams: {
          updatedDocName: sharedDocName,
          ...sharedDocLink && { updatedDocLink: sharedDocLink },
          ...docDescriptionInput && { updatedDocDescription: docDescriptionInput }
        }
      })
    }

    setSaveInProgress(true)
  }

  const handleClickModalCloseButton = () => {
    handleCloseModal()
  }

  const handleChange = (event) => {

    if (event.target.name === "shareDocName") {
      setSharedDocName(event.target.value)
    }

    if (event.target.name === "shareDocLink") {
      setSharedDocLink(event.target.value)
    }

    if (event.target.name === "sharedDocDescription") {
      const trimmedString = event.target.value ? event.target.value.trim() : "";
      setDocDescriptionInput(trimmedString)
    }

  }

  const renderContent = () => {
    return (
      <Box w="100%" align="center">
        <Flex w={isMobileView ? '100%' : '80%'} minW={!isMobileView && '30em'} direction='column' align='center' mb='2em' px='2em'>
          <Flex w='100%' my='1em'>
            <Flex justify='center' w='100%'>
              <Box w='100%' maxW={!isMobileView && '25em'} p={'1em'} justify='center'>
                
                <Flex w='100%' justify='center' mt='1em'>
                  <Box as={IoDocumentText} boxSize="3em" color="brand.500" />
                </Flex>

                <Flex fontSize='1.25em' color='brandDark.500' fontWeight='600' my='1em' justify='center'>
                  <Box>Edit <i>{editedSharedDocName ? editedSharedDocName : 'shared document'}</i></Box>
                </Flex>

                <Flex w='100%' direction='column' justify='center' align='center' gap='1em'>
                  <LaunchdeckFormInput
                    label='Document name'
                    name={'shareDocName'}
                    onChange={handleChange}
                    value={sharedDocName}
                    isRequired={true}
                    isDisabled={saveInProgress}
                  />


                  <Box w='100%'>
                    {(editedSharedDocFileKey) ?
                      <Flex w='100%' mt='0.5em' justify='flex-start'>
                        <Flex position='relative' w='100%' mb='1em' justify='center' border='1px solid' borderColor='gray.300' p='0.875em' bg='white' rounded='0.25em'>

                          <Flex position='absolute' top='-1em' left='0.5em' bg='white' px='0.5em' fontSize='0.7em' color='gray.500' >
                            File
                          </Flex>
                          <Box position='absolute' top='0.5em' right='0.5em' mb='1em'>

                            <Popover
                              isOpen={isOpen}
                              onOpen={onOpen}
                              onClose={onClose}
                              placement="right"
                              closeOnBlur={false}
                              closeOnEsc
                            >
                              <PopoverTrigger>
                                <Box>
                                  <Box as={IoCloseOutline} boxSize='0.875em' cursor='pointer'
                                    onClick={() => { onToggle() }}
                                  />
                                </Box>
                              </PopoverTrigger>
                              <PopoverContent p={5} minW='20em' boxShadow={'xs'} ml='1em'>
                                <PopoverArrow />
                                <Box w='100%' >
                                  <Flex fontSize='0.875em' color='brandPink.500' fontWeight='600'>
                                    Replacing this file?
                                  </Flex>
                                  <Flex mt='1em' fontSize='0.8em' justify='flex-start' textAlign='left'>
                                    It's recommended to delete & create a new shared document.
                                  </Flex>

                                  <Flex mt='1.5em' fontSize='0.7em' fontWeight='600' color='gray.700'>
                                    Why?
                                  </Flex>
                                  <Flex mt='0.5em' fontSize='0.8em' justify='flex-start' textAlign='left' color='gray.500'>
                                    This provides clearer communications to Room members that a new document is available rather than quietly replaced.
                                  </Flex>
                                </Box>
                              </PopoverContent>
                            </Popover>


                          </Box>

                          <Box>
                            <Box
                              fill="brandDark.500"
                              as={FaFileCircleCheck}
                              width="2.5em"
                              height="1.5em"
                              my="0.75em"
                            />
                            <Box fontSize='0.875em' maxW='15em' className='truncate-long-text'>{editedSharedDocName}</Box>
                          </Box>


                        </Flex>

                      </Flex>
                      :
                      <Box w='100%'>
                        <LaunchdeckFormInput
                          label='Link'
                          name={'shareDocLink'}
                          onChange={handleChange}
                          value={sharedDocLink}
                          isRequired={true}
                          isDisabled={saveInProgress}
                        />
                      </Box>
                    }
                  </Box>

                  <Box w='100%'>
                    <LaunchdeckFormTextAreaInput
                      label="Description"
                      name="sharedDocDescription"
                      onChange={handleChange}
                      value={docDescriptionInput}
                      charLimit={250}
                      isDisabled={saveInProgress}
                      showIsOptional={true}
                      fontSize='0.875em'
                      placeholder={`(Optional) Provide a short note to let others know what it is about`}
                    />
                  </Box>
                </Flex>

                <Flex mt='2em'>
                  <LaunchdeckButton bg='brand.500' color='white' w='100%' px='3em' label='Save' onClick={() => handleSaveButton()} loadingLogic={saveInProgress} />
                </Flex>
              </Box>
            </Flex>
          </Flex>
        </Flex>
      </Box>
    )
  }

  const displayContent = () => {
    return (
      <Flex direction='column' mt='1em' justify='center' alignItems='center' px={isMobileView ? '1em' : '0.5em'} w='100%'>
        {renderContent()}
      </Flex>
    )
  }


  return (
       <LaunchdeckModal
            // title={''}
            handleCloseModal={handleClickModalCloseButton}
            showModal={true}
            maxW='35em'
          >
             <Box my='1em' border={'1px solid'} borderColor={'gray.300'} rounded='0.25em' bg='gray.50'>

             {displayContent()}

             </Box>

          </LaunchdeckModal>
  )
}


const mapStateToProps = (state) => ({
  isMobileView: state.mobileViewMode.isMobileView,
  dsrTemplateId: state.dsrTemplateId.results,
  isRoomTemplate: state.dsrTemplateId.isRoomTemplate
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      manageSharedDoc
    },
    dispatch,
  )


export default memo(withRouter(connect(mapStateToProps, mapDispatchToProps)(EditSharedDocModal)))
